import * as fromDatatype from '../datatype-library/index';

export interface bl_mrp_process_template_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;                         
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;                 
    process_template_code: fromDatatype.VarcharDatatypeInterface;               
    process_type_code: fromDatatype.VarcharDatatypeInterface;                   
    template_type: fromDatatype.VarcharDatatypeInterface;                       
    template_description: fromDatatype.TextDatatypeInterface;                
    machine_1_code: fromDatatype.VarcharDatatypeInterface;                      
    machine_2_code: fromDatatype.VarcharDatatypeInterface;                      
    machine_3_code: fromDatatype.VarcharDatatypeInterface;                      
    machine_4_code: fromDatatype.VarcharDatatypeInterface;                      
    output_item_code: fromDatatype.VarcharDatatypeInterface;                    
    output_uom: fromDatatype.VarcharDatatypeInterface;                          
    output_ratio: fromDatatype.NumericDatatypeInterface;                        
    output_description: fromDatatype.TextDatatypeInterface;                  
    input_1_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_1_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_1_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_1_description: fromDatatype.TextDatatypeInterface;                 
    input_2_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_2_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_2_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_2_description: fromDatatype.TextDatatypeInterface;                 
    input_3_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_3_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_3_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_3_description: fromDatatype.TextDatatypeInterface;                 
    input_4_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_4_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_4_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_4_description: fromDatatype.TextDatatypeInterface;                 
    input_5_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_5_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_5_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_5_description: fromDatatype.TextDatatypeInterface;                 
    input_6_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_6_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_6_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_6_description: fromDatatype.TextDatatypeInterface;                 
    input_7_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_7_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_7_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_7_description: fromDatatype.TextDatatypeInterface;                 
    short_error_message: fromDatatype.TextDatatypeInterface;                 
    error_stack_trace: fromDatatype.TextDatatypeInterface;                   
    line_number: fromDatatype.IntegerDatatypeInterface;                         
    validated: boolean;                           
    processed: boolean;                           
    applet_guid: fromDatatype.GuidDataFieldInterface;                           
    module_guid: fromDatatype.GuidDataFieldInterface;                           
    property_json: any;                      
    acl_config: any;                          
    acl_policy: any;                        
    created_date: fromDatatype.TimestampTzDatatypeInterface;                        
    updated_date: fromDatatype.TimestampTzDatatypeInterface;                        
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;               
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;               
    status: fromDatatype.StatusDataFieldInterface;                              
    revision: fromDatatype.RevisionDataFieldInterface;                            
    vrsn: fromDatatype.VrsnDataFieldInterface;                                
}

export class bl_mrp_process_template_import_file_helper_RowClass implements bl_mrp_process_template_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;                         
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;                 
    process_template_code: fromDatatype.VarcharDatatypeInterface;               
    process_type_code: fromDatatype.VarcharDatatypeInterface;                   
    template_type: fromDatatype.VarcharDatatypeInterface;                       
    template_description: fromDatatype.TextDatatypeInterface;                
    machine_1_code: fromDatatype.VarcharDatatypeInterface;                      
    machine_2_code: fromDatatype.VarcharDatatypeInterface;                      
    machine_3_code: fromDatatype.VarcharDatatypeInterface;                      
    machine_4_code: fromDatatype.VarcharDatatypeInterface;                      
    output_item_code: fromDatatype.VarcharDatatypeInterface;                    
    output_uom: fromDatatype.VarcharDatatypeInterface;                          
    output_ratio: fromDatatype.NumericDatatypeInterface;                        
    output_description: fromDatatype.TextDatatypeInterface;                  
    input_1_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_1_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_1_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_1_description: fromDatatype.TextDatatypeInterface;                 
    input_2_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_2_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_2_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_2_description: fromDatatype.TextDatatypeInterface;                 
    input_3_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_3_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_3_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_3_description: fromDatatype.TextDatatypeInterface;                 
    input_4_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_4_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_4_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_4_description: fromDatatype.TextDatatypeInterface;                 
    input_5_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_5_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_5_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_5_description: fromDatatype.TextDatatypeInterface;                 
    input_6_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_6_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_6_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_6_description: fromDatatype.TextDatatypeInterface;                 
    input_7_item_code: fromDatatype.VarcharDatatypeInterface;                   
    input_7_uom: fromDatatype.VarcharDatatypeInterface;                         
    input_7_ratio: fromDatatype.NumericDatatypeInterface;                       
    input_7_description: fromDatatype.TextDatatypeInterface;                 
    short_error_message: fromDatatype.TextDatatypeInterface;                 
    error_stack_trace: fromDatatype.TextDatatypeInterface;                   
    line_number: fromDatatype.IntegerDatatypeInterface;                         
    validated: boolean;                           
    processed: boolean;                           
    applet_guid: fromDatatype.GuidDataFieldInterface;                           
    module_guid: fromDatatype.GuidDataFieldInterface;                           
    property_json: any;                      
    acl_config: any;                          
    acl_policy: any;                        
    created_date: fromDatatype.TimestampTzDatatypeInterface;                        
    updated_date: fromDatatype.TimestampTzDatatypeInterface;                        
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;               
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;               
    status: fromDatatype.StatusDataFieldInterface;                              
    revision: fromDatatype.RevisionDataFieldInterface;                            
    vrsn: fromDatatype.VrsnDataFieldInterface;   
}